import React from 'react';
import './Privacy.css';

function Privacy() {
  return (
    <div className="privacy-page">
      <header className="privacy-header">
        <h1 className="privacy-title">Privacy policy</h1>
        <p className="privacy-description">
        Privacy Policy

This privacy policy applies to the itiniri llc app (hereby referred to as "Application") for mobile devices that was created by Itiniri LLC (hereby referred to as "Service Provider") as a Free service. This service is intended for use "AS IS".
<br />
Information Collection and Use
<br />
The Application collects information when you download and use it. This information may include information such as
<br />
Your device's Internet Protocol address (e.g. IP address)
<br />
The pages of the Application that you visit, the time and date of your visit, the time spent on those pages
<br />
The time spent on the Application
<br />
The operating system you use on your mobile device
<br />
The Application does not gather precise information about the location of your mobile device.
<br />
The Service Provider may use the information you provided to contact you from time to time to provide you with important information, required notices and marketing promotions.
<br />
For a better experience, while using the Application, the Service Provider may require you to provide us with certain personally identifiable information, including but not limited to Email. The information that the Service Provider request will be retained by them and used as described in this privacy policy.
<br />
Third Party Access
<br />
Only aggregated, anonymized data is periodically transmitted to external services to aid the Service Provider in improving the Application and their service. The Service Provider may share your information with third parties in the ways that are described in this privacy statement.
<br />
Please note that the Application utilizes third-party services that have their own Privacy Policy about handling data. Below are the links to the Privacy Policy of the third-party service providers used by the Application:
<br />
Google Play Services
<br />
Google Analytics for Firebase
<br />
Firebase Crashlytics
<br />
Expo
<br />
The Service Provider may disclose User Provided and Automatically Collected Information:

as required by law, such as to comply with a subpoena, or similar legal process;

when they believe in good faith that disclosure is necessary to protect their rights, protect your safety or the safety of others, investigate fraud, or respond to a government request;

with their trusted services providers who work on their behalf, do not have an independent use of the information we disclose to them, and have agreed to adhere to the rules set forth in this privacy statement.
<br />
Opt-Out Rights
<br />
You can stop all collection of information by the Application easily by uninstalling it. You may use the standard uninstall processes as may be available as part of your mobile device or via the mobile application marketplace or network.
<br />
Data Retention Policy
<br />
The Service Provider will retain User Provided data for as long as you use the Application and for a reasonable time thereafter. If you'd like them to delete User Provided Data that you have provided via the Application, please contact them at albie@itiniri.com and they will respond in a reasonable time.
<br />
Children
<br />
The Service Provider does not use the Application to knowingly solicit data from or market to children under the age of 13.
<br />
The Application does not address anyone under the age of 13. The Service Provider does not knowingly collect personally identifiable information from children under 13 years of age. In the case the Service Provider discover that a child under 13 has provided personal information, the Service Provider will immediately delete this from their servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact the Service Provider (albie@itiniri.com) so that they will be able to take the necessary actions.
<br />
Security
<br />
The Service Provider is concerned about safeguarding the confidentiality of your information. The Service Provider provides physical, electronic, and procedural safeguards to protect information the Service Provider processes and maintains.
<br />
Changes
<br />
This Privacy Policy may be updated from time to time for any reason. The Service Provider will notify you of any changes to the Privacy Policy by updating this page with the new Privacy Policy. You are advised to consult this Privacy Policy regularly for any changes, as continued use is deemed approval of all changes.
<br />
This privacy policy is effective as of 2024-07-23
<br />
Your Consent
<br />
By using the Application, you are consenting to the processing of your information as set forth in this Privacy Policy now and as amended by us.
<br />
Contact Us
<br />
If you have any questions regarding privacy while using the Application, or have questions about the practices, please contact the Service Provider via email at albie@itiniri.com.
<br />
This privacy policy page was generated by App Privacy Policy Generator        </p>
      </header>
    </div>
  );
}

export default Privacy;
